import styled from 'styled-components';

export const WrapperUser = styled.div`
  display: flex;
  width: 360px;
  border-radius: 4px;
  padding: 8px;
`;

export const ImageUser = styled.img`
  width: 100px;
  height: auto;
  max-height: 90%;
  border-radius: 5px;
`;

export const ContentUser = styled.div`
  display: flex;
  flex-direction: column;
  width: 180px;
  align-items: flex-end;

  h3{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    margin: 5px;
    color: #565656;
  }

  h4{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 16px;
    color: #A1A1A1;
    margin: 0;
  }

  p{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 20px;
    color: #A1A1A1;
    margin: 12px;
  }

  b{
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 16px;
    color: #F07E31;
    margin: 0;
  }
`;
